<template>
  <b-table-simple class="orderable-text-list-wrapper border" sticky-header>
    <b-thead>
      <b-tr>
        <b-th
          v-for="tableField in tableFields"
          :key="`th-${tableField.key}`"
          :style="tableField.thStyle"
        >
          {{ tableField.label }}
        </b-th>
      </b-tr>
    </b-thead>

    <draggable v-if="localValue.length > 0" v-model="localValue" tag="tbody" handle=".drag-handle">
      <b-tr v-for="(_, index) in localValue" :key="index">
        <template v-for="(tableField, tableIdx) in tableFields">
          <b-td
            v-if="tableField.key === 'drag-handle'"
            :key="`td-drag-handle-${tableIdx}`"
            class="drag-handle"
          >
            <div class="drag-wrapper">
              <span class="drag-handler mc-fa icon-outline_move" />
              <div class="order-badge-wrapper">
                <div class="order-label">
                  {{ index + 1 }}
                </div>
              </div>
            </div>
          </b-td>
          <b-td v-else-if="tableField.key === 'delete-btn'" :key="`td-delete-btn-${tableIdx}`">
            <b-button variant="outline" :disabled="disabled" @click="onRemoveItem(index)">
              <i class="mc-icon icon-outline_trash" />
            </b-button>
          </b-td>
          <b-td v-else :key="`td-input-col-${tableField.key}`">
            <SuggestionSelect
              :ref="`suggestion-select-${index}`"
              v-model="localValue[index]"
              :field="field"
              :disabled="disabled"
            />
          </b-td>
        </template>
      </b-tr>
    </draggable>

    <b-tbody v-else>
      <b-tr>
        <b-td colspan="3" class="text-center">Tidak ada data tersedia</b-td>
      </b-tr>
    </b-tbody>
  </b-table-simple>
</template>

<script>
import draggable from 'vuedraggable'
import SuggestionSelect from './SuggestionSelect'

// How to create Orderable Text List Input
// <OrderableTextListInput
//  v-model="formValues"
//  :field="{
//    name: 'customer_name',
//    placeholder: 'Masukkan Nama Pelanggan',
//    type: 'taggable-select-input',
//    labelColumn: 'Customer Name',
//    labelKey: 'value',
//    validation: [
//      ['bail'],
//      ['optional'],
//      ['min', 2],
//      ['max', 144],
//    ],
//    optionLabelFn: (item) => item.item.value,
//  }"
// />
// <b-button
//  @click="() => formValues.push(null)"
// >
//  add new row
// </b-button>

export default {
  components: {
    draggable,
    SuggestionSelect,
  },
  props: {
    value: {
      type: Array,
      default: () => {},
    },
    field: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    localValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      },
    },
    tableFields() {
      return [
        {
          key: 'drag-handle',
          thStyle: 'min-width: 80px;',
        },
        {
          key: this.field?.name ?? 'column',
          label: this.field?.labelColumn ?? 'Column',
          thStyle: 'width: 100%; min-width: 300px;',
        },
        {
          key: 'delete-btn',
          thStyle: 'min-width: 60px;',
        },
      ]
    },
  },
  methods: {
    Refs(index) {
      return this.$refs[`suggestion-select-${index}`]?.[0]?.$refs['suggestion-select']
    },
    onRemoveItem(index) {
      this.localValue.splice(index, 1)
    },
  },
}
</script>

<style lang="scss" scoped>
.orderable-text-list-wrapper {
  user-select: none;

  :deep(table) {
    height: fit-content;
    tr {
      height: 100%;
    }
  }

  :deep(.mc-icon::before) {
    color: $red;
  }

  .drag-wrapper {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    cursor: grab;

    .mc-fa {
      font-size: 16px;
    }

    .order-badge-wrapper {
      display: flex;
      position: relative;
      height: 100%;
      align-items: center;

      .order-label {
        display: flex;
        background-color: $mep-secondary;
        color: $white;
        font-size: 11px;
        justify-content: center;
        align-items: center;
        height: 20px;
        width: 20px;
        border-radius: 100%;
        z-index: 10;
      }

      &::before,
      &::after {
        content: '';
        position: absolute;
        border-right: 1px dashed $mep-color-text-200;
        right: 50%;
        height: 100%;
      }

      &::before {
        bottom: 50%;
      }

      &::after {
        top: 50%;
      }
    }
  }

  tr:first-child .order-badge-wrapper::before,
  tr:last-child .order-badge-wrapper::after {
    display: none;
  }
}
</style>
